// StickyFilters.js
import React from 'react';
import { 
  Box,
  Container,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  UnfoldLess,
  UnfoldMore,
  FilterList,
} from '@mui/icons-material';
import SharedFilters from './sharedFilters';

const StickyFilters = ({
  schools,
  selectedSchool,
  governanceFilter,
  selectedGrades,
  selectedDriveTime,
  selectedTravelMode,
  schoolTypeFilter,
  availableSchoolTypes,
  availableDriveTimes = null,
  availableTravelModes = null,
  onSchoolChange,
  onGovernanceChange,
  onGradeChange,
  onDriveTimeChange,
  onTravelModeChange,
  onSchoolTypeChange,
  onHasPreKChange,
  expandedSections,
  onExpandAll,
  onCollapseAll,
  showSchoolType = true,
}) => {
  const isAllExpanded = Object.values(expandedSections).every(value => value === true);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'grey.50',
        backdropFilter: 'blur(8px)',
        zIndex: 1200,
        borderBottom: '1px solid',
        borderColor: 'grey.200',
        py: { xs: 2, md: 1.5 },  // More padding on mobile for two rows
        mb: 3,
        width: '100%',
        height: 'auto',
        minHeight: 'fit-content',
        boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
      }}
    >
      <Container 
        maxWidth={false}
        sx={{
          px: { xs: 2, sm: 3 },
          display: 'flex',
          alignItems: { xs: 'flex-start', md: 'center' },  // Align to top on mobile
          gap: 2,
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Tooltip title="Filters">
          <FilterList 
            color="primary" 
            sx={{ 
              opacity: 0.8,
              '&:hover': { opacity: 1 },
              mt: { xs: 1, md: 0 }  // Adjust icon position on mobile
            }} 
          />
        </Tooltip>
        
        <Box sx={{ flex: 1 }}>
          <SharedFilters
            schools={schools}
            selectedSchool={selectedSchool}
            governanceFilter={governanceFilter}
            selectedGrades={selectedGrades}
            selectedDriveTime={selectedDriveTime}
            selectedTravelMode={selectedTravelMode}
            schoolTypeFilter={schoolTypeFilter}
            availableSchoolTypes={availableSchoolTypes}
            availableDriveTimes={availableDriveTimes}
            availableTravelModes={availableTravelModes}
            onSchoolChange={onSchoolChange}
            onGovernanceChange={onGovernanceChange}
            onGradeChange={onGradeChange}
            onDriveTimeChange={onDriveTimeChange}
            onTravelModeChange={onTravelModeChange}
            onSchoolTypeChange={onSchoolTypeChange}
            onHasPreKChange={onHasPreKChange}
            showSchoolType={showSchoolType}
            compact={true}
            sticky={true}
            singleRow={true}
          />
        </Box>

        <Tooltip title={isAllExpanded ? "Collapse all sections" : "Expand all sections"}>
          <IconButton 
            onClick={isAllExpanded ? onCollapseAll : onExpandAll}
            size="small"
            sx={{ 
              color: 'primary.main',
              opacity: 0.8,
              mt: { xs: 1, md: 0 },  // Adjust button position on mobile
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'primary.dark',
                opacity: 1
              }
            }}
          >
            {isAllExpanded ? <UnfoldLess /> : <UnfoldMore />}
          </IconButton>
        </Tooltip>
      </Container>
    </Box>
  );
};

export default StickyFilters;